/**
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
function mmMegaMenuShowProducts(classElemsToHide, classElemToShow) {
    var imageContainers = document.querySelectorAll(classElemsToHide);
    imageContainers.forEach(function(imageContainer) {
        imageContainer.style.display = 'none';
    });
    document.querySelector(classElemToShow).style.display = 'grid';
}

/**
 * Adjust the position of the mega menu based on the header height.
 */
function getMegaMenuPosition() {
    var menuElems = document.querySelectorAll('.mm-header-link');
    var header = document.querySelector('.mm-section-header');
    if (header) {
      var headerHeight = header.offsetHeight;
    }

    menuElems.forEach(function(menuElem) {
        if (menuElem.nextElementSibling) {
            if (menuElem.nextElementSibling.classList.contains('mm-mega-menu-wrapper') || menuElem.nextElementSibling.classList.contains('mm-header-submenu')) {
                menuElem.nextElementSibling.style.top = `${headerHeight}px`;
            }
        }
    });
}

/**
 * Add background filter on hover over mega menu links.
 */
function hoverBgFilter() {
    const header = document.querySelector('.mm-header');
    const megaMenuLinks = document.querySelectorAll('.mm-header-link-mega-menu');

    megaMenuLinks.forEach(megaMenuLink => {
        megaMenuLink.addEventListener('mouseenter', () => {
            showBgFilter();
        });
        header.addEventListener('mouseleave', () => {
            hideBgFilter();
        });
    });
}

/**
 * Show background filter.
 */
function showBgFilter() {
    const filter = document.querySelector('.mm-filter-mega-menu');
    filter.classList.add("active");
}

/**
 * Hide background filter.
 */
function hideBgFilter() {
    const filter = document.querySelector('.mm-filter-mega-menu');
    filter.classList.remove("active");
}

/* Animation Searchbar mobile */
function animSearchBarMobile() {
  const searchContainer = document.querySelector(".mm-header-search-container");

  document.addEventListener("scroll", function () {
		if (window.scrollY > 100) {
			searchContainer.classList.remove("bottom");

		} else {
			searchContainer.classList.add("bottom");
		}
  });
}

/*
* Change opacité au hover d'un lien du menu
*
*/
function changeOpacityMenuLinks () {
  const header = document.querySelector(".mm-header");
  const links = header.querySelectorAll(".mm-header-link-opacity");
  links.forEach((link) => {
		link.addEventListener("mouseover", () => {
			links.forEach((otherLink) => {
				if (otherLink !== link) {
					otherLink.style.opacity = "0.5"; // Applique une opacité de 0.5 aux autres liens
				}
			});
		});

		link.addEventListener("mouseout", () => {
			links.forEach((otherLink) => {
				otherLink.style.opacity = "1"; // Réinitialise l'opacité de tous les liens à 1
			});
		});
  });
}


/**
 * Open external links in a new tab unless it's the consent modale.
 */
function externalLink() {
	var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (!links[i].classList.contains('consent-wrapper') && links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }
}

/**
 * Toggle the mobile menu.
 */
function mmMobileMenu() {
    if (window.innerWidth <= 1000) {
        const filter = document.querySelector('.mm-filter-mega-menu');
        const header = document.querySelector("header");
        const icon = document.querySelector(".mm-header-burger");
        const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
        console.log('mobile menu', mobileMenu)
        // const mobileMenuSecondary = document.querySelector(".mm-mobile-menu-wrapper .mm-header-mobile-sublinks");
        let headerMenu = document.querySelector('.mm-header');
        // let headerHeight = headerMenu.offsetHeight;
        // let headerMenuTop = headerMenu.getBoundingClientRect().top;

        filter.classList.add("active");
        header.classList.toggle("mm-open");
        icon.classList.toggle("mm-open");
        mobileMenu.classList.toggle("mm-menu-open");
        document.querySelector("html").classList.toggle("stop-scrolling");
        // mobileMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
        // mobileMenu.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
        // mobileMenuSecondary.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
    }
}

function mmHideSearch() {

}

/**
 * Close the mobile menu.
 */
function mmCloseMobileMenu() {
    if (window.innerWidth <= 768) {
        const header = document.querySelector("header");
        const icon = document.querySelector(".mm-header-burger");
        const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

        header.classList.remove("mm-open");
        icon.classList.remove("mm-open");
        document.querySelector("html").classList.toggle("stop-scrolling");
        mobileMenu.classList.remove("mm-menu-open");
        hideBgFilter();
    }
}

/**
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
function mmMobileMenuShowNext(elemToShowClass) {

    let elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.add('mm-mobile-menu-elem-slided');
}

/**
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
function mmMobileMenuShowPrev(elemToShowClass) {
    var elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.remove('mm-mobile-menu-elem-slided');
}

/**
 * Handle dropdown behavior.
 */
function handleDropdown() {
    const dropWrapper = document.querySelectorAll('.mm-drop-wrapper');

    // Ouvrir le dropdown de description par défaut en mobile
    if (window.innerWidth <= 1024) {
        const descriptionDropdown = document.querySelector('.mm-product-info-dropdown-description .mm-drop-wrapper');
        if (descriptionDropdown) {
            descriptionDropdown.classList.add('active');
            const content = descriptionDropdown.nextElementSibling;
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }

    dropWrapper.forEach((item) => {
        item.addEventListener('click', function () {
            // Close all other dropdowns
            dropWrapper.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    el.nextElementSibling.style.maxHeight = null;
                }
            });

            // Toggle the current dropdown
            this.classList.toggle('active');

            const content = this.nextElementSibling;

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + 'px';
            }
        });
    });
}

/**
 * Set the document height CSS variable to the current window height.
 */
const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

// Custom element for product recommendations
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    } else {
                        this.style.display = "none";
                    }

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

document.addEventListener("DOMContentLoaded", (event) => {
    getMegaMenuPosition();
    if ( window.innerWidth > 1100) {
        changeOpacityMenuLinks();
    }
    if (window.innerWidth <= 768) {
        animSearchBarMobile();

    }

    hoverBgFilter();
    handleDropdown();
    externalLink();
});

window.addEventListener('resize', documentHeight);
documentHeight();

// Handle pictogramme hover product card
function handlePictogrammeHover() {
    const pictogrammes = document.querySelectorAll('.mm-product-card-pictogramme-div');
    
    pictogrammes.forEach(pictogramme => {
      pictogramme.addEventListener('mouseenter', (e) => {
        const tooltip = pictogramme.querySelector('.mm-product-card-pictogramme-text');
        if (!tooltip) return;
        
        // Créer une copie du tooltip
        const tooltipClone = tooltip.cloneNode(true);
        tooltipClone.classList.add('tooltip-clone');
        
        // Calculer la position
        const rect = pictogramme.getBoundingClientRect();
        tooltipClone.style.position = 'fixed';
        tooltipClone.style.left = `${rect.right + 5}px`;
        tooltipClone.style.top = `${rect.top + 2}px`;
        tooltipClone.style.display = 'flex';
        
        // Ajouter au body
        document.body.appendChild(tooltipClone);
      });
      
      pictogramme.addEventListener('mouseleave', () => {
        // Supprimer tous les tooltips clonés
        document.querySelectorAll('.tooltip-clone').forEach(clone => clone.remove());
      });
    });
  }
  
  // Initialiser quand le DOM est chargé
  document.addEventListener('DOMContentLoaded', handlePictogrammeHover); 